const SELECTORS = {
	button: '.resend-code__button',
	timer: '.resend-code__timer',
	container: '.resend-code',
	codeAvailableAt: 'data-code-available-at',
	textElement: '.resend-code__text',
};

const CLASSES = {
	hidden: 'display--none',
};

export class ResendCode {
	constructor() {
		this.button = document.querySelector(SELECTORS.button);
		this.timer = document.querySelector(SELECTORS.timer);
		this.container = document.querySelector(SELECTORS.container);
		this.textElement = document.querySelector(SELECTORS.textElement);

		const requiredElements = [this.button, this.timer, this.container, this.textElement];

		if (requiredElements.some((el) => !el)) {
			return;
		}

		this.codeAvailableAt = this.container.getAttribute(SELECTORS.codeAvailableAt);
		this.countdownInterval = null;
		this.remainingTime = 0;

		this.bindEvents();
		this.setup();
	}

	static init() {
		// eslint-disable-next-line
		new ResendCode();
	}

	bindEvents() {
		['handleButtonClick', 'updateTimer', 'showButton'].forEach((e) => {
			this[e] = this[e].bind(this);
		});
	}

	handleButtonClick() {
		this.updateTextElement();
	}

	startCountdown() {
		// Use the current remainingTime that was set in setup()
		this.updateTimer();

		this.countdownInterval = setInterval(() => {
			this.remainingTime -= 1;
			this.updateTimer();

			if (this.remainingTime <= 0) {
				this.stopCountdown();
				this.showButton();
				this.hideTimer();
			}
		}, 1000);
	}

	stopCountdown() {
		if (this.countdownInterval) {
			clearInterval(this.countdownInterval);
			this.countdownInterval = null;
		}
	}

	updateTimer() {
		const minutes = Math.floor(this.remainingTime / 60);
		const seconds = this.remainingTime % 60;

		const formattedTime = `${minutes.toString().padStart(2, '0')}:${seconds
			.toString()
			.padStart(2, '0')}`;
		this.timer.textContent = formattedTime;
	}

	updateTextElement() {
		if (this.remainingTime > 0) {
			this.textElement.textContent =
				this.textElement.getAttribute('data-resend-code-in-text') || 'Resend code in';
		} else {
			this.textElement.textContent =
				this.textElement.getAttribute('data-did-not-receive-code-text') || 'Did not receive code?';
		}
	}

	hideButton() {
		this.button.classList.add(CLASSES.hidden);
	}

	showButton() {
		this.button.classList.remove(CLASSES.hidden);
		this.updateTextElement();
	}

	hideTimer() {
		this.timer.classList.add(CLASSES.hidden);
	}

	showTimer() {
		this.timer.classList.remove(CLASSES.hidden);
	}

	calculateRemainingTime() {
		if (!this.codeAvailableAt) {
			return 0; // No timestamp, show button immediately
		}

		const futureTimestamp = parseInt(this.codeAvailableAt, 10) * 1000; // Convert to milliseconds
		const currentTime = Date.now();
		const remaining = Math.max(0, Math.ceil((futureTimestamp - currentTime) / 1000));

		return remaining;
	}

	setupEventListeners() {
		this.button.addEventListener('click', this.handleButtonClick);
	}

	setup() {
		this.setupEventListeners();

		// Check if we should start countdown or show button immediately
		const remainingTime = this.calculateRemainingTime();

		if (remainingTime > 0) {
			// Start countdown with remaining time
			this.remainingTime = remainingTime;
			this.startCountdown();
			this.hideButton();
			this.showTimer();
		} else {
			// No countdown needed, show button
			this.hideTimer();
			this.showButton();
		}

		// Update the text element with appropriate translation
		this.updateTextElement();
	}

	destroy() {
		this.stopCountdown();
		if (this.button) {
			this.button.removeEventListener('click', this.handleButtonClick);
		}
	}
}
